module.exports = __webpack_public_path__ + "static/media/location-direction.f129a961.svg";